/**
 * @file 微博服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';

export default class WeiboServiceDetailModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'weibo';
}
